import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SolrEntityService} from "@signature-it/ngx-entity/services";
import {Subject} from "rxjs";
import {DomSanitizer} from "@angular/platform-browser";
import {EventName} from "@signature-it/ngx-generic/classes";
import {EventBusService} from "@signature-it/ngx-generic/services";
declare let _ : any;
@Component({
    selector: 'taxonomy-sidenav-content',
    templateUrl: './taxonomy-sidenav-content.component.html',
    styleUrls: ['./taxonomy-sidenav-content.component.scss'],
    standalone: false
})
export class TaxonomySidenavContentComponent implements OnInit, OnDestroy {
    @Input() key: number;
    html;
    scripts;
    scriptsReg = /<script\b[^>]*>[\s\S]*?<\/script\b[^>]*>/g;
    private destroy$: Subject<void> = new Subject<void>();
    constructor(protected eventBusService: EventBusService,
                protected solrEntityService: SolrEntityService,
                protected sanitizer: DomSanitizer
    ) {}

    ngOnInit() {
        this.eventBusService.on(EventName.TAXONOMY_NODE_CLICK, data => {
            if(data.key != this.key) return;
            this.solrEntityService.getEntity( Number(data.nodeId))
                .subscribe(
                    res => {
                        const doc = (res.response && res.response.docs)? res.response.docs[0] : {};
                        if(doc) {
                            let data = this.b64DecodeUnicode(doc['page_content_lg']);
                            this.scripts = this.transform( data.match(this.scriptsReg)?.join('') || '');
                            this.html = this.transform( data);
                        }else{
                            this.scripts = null;
                            this.html = null;
                        }
                    });
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    b64DecodeUnicode(str) {
        try {
            return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        } catch (e) {
            return '';
        }
    }


    transform(html) {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

}
